<template>
    <div class="case-item first:!col-start-1" :class="size">
        <NuxtLink :to="localePath(`/case/${slug}`)" class="w-full">
            <div class="w-full flex flex-col gap-4">
                <div
                    class="case-item-image w-full overflow-hidden bg-background-accent relative rounded-sm"
                    :class="{
                        'case-item-image--full': size === CaseItemWidth.full,
                        'case-item-image--big': size === CaseItemWidth.big,
                    }"
                >
                    <div class="w-full h-full absolute top-1/2 right-0 bottom-0 left-1/2 -translate-y-1/2 -translate-x-1/2 hover:w-[105%] hover:h-[105%] transition-all rounded-sm overflow-hidden">
                        <ResponsiveImage
                            v-if="image"
                            :image-id="image"
                            class="object-cover w-full h-full ease-in-out"
                        />
                    </div>

                </div>
                <div class="flex flex-col gap-0">
                    <h4 class="view-h4 uppercase">{{ get_hyphenated_content(title) }}</h4>
                    <div class="view-body-small" v-if="credit">{{ credit }}</div>

                </div>
            </div>
        </NuxtLink>
    </div>
</template>


<script lang="ts">
export enum CaseItemWidth {
    full = 'col-span-full !col-start-1',
    small = 'w-full md:col-span-4',
    big = 'w-full md:col-span-8',
}
</script>

<script lang="ts" setup>
import SetImg from "~/components/view/SetImg.vue"

const localePath = useLocalePath()
const { get_hyphenated_content } = useTextUtils()

const {slug, contentId, image, title, subtitle, credit, size} = defineProps({
    contentId: String,
    slug: String,
    image: String,
    title: String,
    subtitle: String,
    credit: String,
    size: String as PropType<CaseItemWidth>
})

const build_cols = computed(() => {
    let cols = {sm: 12, md: 3, lg: 3}
    if (size == CaseItemWidth.big) cols = {sm: 12, md: 6, lg: 6}
    else if (size == CaseItemWidth.full) cols = {sm: 12, md: 12, lg: 12}
    return cols

})

</script>

<style scoped>
.case-item {
    container-type: inline-size;
}

.case-item-image {
    aspect-ratio: 4 / 5;
}

@media (width >= 768px) {
    .case-item-image--big {
        aspect-ratio: auto;
        height: calc(62.5cqw - 0.625rem);
    }

    .case-item-image--full {
        aspect-ratio: auto;
        height: calc(41.6666666667cqw - 0.8333333333rem);
    }
}
</style>
